import * as React from 'react';
import { Canceler } from 'axios';
import { Link } from 'react-router-dom';

import { IOption } from 'src/components/Form/Select';

import API from 'src/services/api';
import { MarketContext } from 'src/services/contexts/markets/MarketContext';
import { Select, Button } from 'src/components';

interface ITemplateSelectionProps {
  profileParameterName: string;
}
interface ITemplateSelectionState {
  marketId: number | null;
  templateId: number | null;
  loadingTemplates: boolean;
  downloadingFile: boolean;
  marketOptions: Array<IOption<number>>;
  templateOptions: Array<IOption<number>>;
}

export default class TemplateSelection extends React.Component<
  ITemplateSelectionProps,
  ITemplateSelectionState
> {
  static contextType = MarketContext;
  context!: React.ContextType<typeof MarketContext>;
  reqCanceler: Canceler | null = null;

  state: ITemplateSelectionState = {
    marketId: null,
    templateId: null,
    loadingTemplates: false,
    downloadingFile: false,
    marketOptions: [],
    templateOptions: [],
  };

  async componentDidMount() {
    const markets = this.context.visibilityProfiles;

    const marketOptions = markets.map((market) => ({
      label: market.name,
      value: market.id,
    }));
    this.setState({
      marketOptions,
    });
  }
  componentWillUnmount() {
    if (this.reqCanceler) {
      this.reqCanceler();
    }
  }

  getTemplates = async (marketId: number) => {
    this.setState({
      loadingTemplates: true,
      templateId: null,
    });

    const { getData, cancel } = API.LINK_UPLOAD.getTemplates(marketId);
    this.reqCanceler = cancel;
    const templates = await getData();
    this.reqCanceler = null;

    const templateOptions = templates.map(
      (template: { name: string; id: number }) => ({
        label: template.name,
        value: template.id,
      })
    );
    this.setState({
      loadingTemplates: false,
      templateOptions,
      templateId:
        templateOptions.length === 1 ? templateOptions[0].value : null,
    });
  };

  onMarketChange = (choice: IOption<any>) => {
    const marketId = choice.value;
    this.setState({
      marketId,
    });
    this.getTemplates(marketId);
  };

  onTemplateChange = (choice: IOption<any>) => {
    this.setState({
      templateId: choice.value,
    });
  };

  render() {
    const {
      marketOptions,
      marketId,
      templateOptions,
      templateId,
      loadingTemplates,
    } = this.state;
    const templateOption = templateOptions.find((o) => o.value === templateId);
    return (
      <form className="absolute pin-l w-128 bg-white px-8 py-6 shadow-lg">
        <div className="mb-6">
          <label className="block mb-2" htmlFor="market">
            Choose a {this.props.profileParameterName}
          </label>
          <Select
            name="market"
            secondary={true}
            onChange={this.onMarketChange}
            options={marketOptions}
            isLoading={!marketOptions.length}
            isDisabled={!marketOptions.length}
          />
        </div>
        <div className="mb-6">
          <label className="block mb-2" htmlFor="template">
            Choose a template
          </label>
          <Select
            name="template"
            secondary={true}
            value={templateOption}
            onChange={this.onTemplateChange}
            options={templateOptions}
            isLoading={loadingTemplates}
            isDisabled={!marketId || loadingTemplates}
          />
        </div>
        <Button
          as={Link}
          to={`/link-bulk-upload/create/${marketId}/${templateId}`}
          className="block w-full"
          disabled={!marketId || !templateId}
        >
          Start creating links
        </Button>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/LinkCreateBulkStart/components/TemplateSelection.tsx